import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ArrowLeft, MoreVertical } from "lucide-react";
import { Link } from "react-router-dom";

interface NavProps {
  showBack?: boolean;
}

export const Nav = ({ showBack }: NavProps) => (
  <nav className="bg-white/80 backdrop-blur-md border-b border-white/20 sticky top-0 z-50 w-full">
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-center items-center h-16 relative">
        {showBack && (
          <div className="absolute left-0 top-1/2 -translate-y-1/2">
            <Button variant="ghost" asChild className="p-2">
              <Link to="/">
                <ArrowLeft className="w-5 h-5" />
              </Link>
            </Button>
          </div>
        )}
        <Link to="/" className="flex items-center">
          <img src="/text-logo.svg" alt="Logo" className="h-6 w-auto" />
        </Link>
        <div className="absolute right-0 top-1/2 -translate-y-1/2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Ouvrir le menu">
                <MoreVertical className="w-5 h-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem asChild>
                <Link to="/account">Mon compte</Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  </nav>
);
